export function booleanToNumber(source) {
  if (typeof source === "boolean") {
    return source ? 1 : 0;
  }
}

export function numberToBoolean(source) {
  if (!source) {
    return !!source;
  }
  if (typeof source === "string") {
    return parseInt(source) === 1;
  }
  if (typeof source === "number") {
    return source === 1;
  }
}
